export default __webpack_public_path__ + "static/media/Location.64cdcb0e.png";